var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayStoreBlack = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 40,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M130 0H5a5 5 0 0 0-5 5v30a5 5 0 0 0 5 5h125a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    d: "M130 .8a4.2 4.2 0 0 1 4.2 4.2v30a4.198 4.198 0 0 1-4.2 4.2H5A4.2 4.2 0 0 1 .8 35V5A4.2 4.2 0 0 1 5 .8zm0-.8H5a5 5 0 0 0-5 5v30a5 5 0 0 0 5 5h125a5.002 5.002 0 0 0 5-5V5a5.002 5.002 0 0 0-5-5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M47.42 10.24a2.72 2.72 0 0 1-.75 2 2.9 2.9 0 0 1-2.2.88 3 3 0 0 1-2.21-.9 3 3 0 0 1-.91-2.22 3 3 0 0 1 .91-2.23 3.16 3.16 0 0 1 3.44-.65c.36.148.682.377.94.67l-.53.53a2 2 0 0 0-1.64-.72 2.32 2.32 0 0 0-2.33 2.4 2.36 2.36 0 0 0 4 1.73 1.93 1.93 0 0 0 .51-1.22h-2.18v-.72h2.91c.023.149.036.3.04.45ZM52 7.74h-2.7v1.9h2.46v.72H49.3v1.9H52V13h-3.48V7H52zM55.28 13h-.77V7.74h-1.68V7H57v.74h-1.72zM59.94 13V7h.77v6zM64.13 13h-.77V7.74h-1.68V7h4.12v.74h-1.67zM73.61 12.22a3.108 3.108 0 0 1-4.4 0 3 3 0 0 1-.88-2.22 3 3 0 0 1 .88-2.22 2.93 2.93 0 0 1 2.2-.91 3 3 0 0 1 2.2.91 3.07 3.07 0 0 1 .88 2.22 3 3 0 0 1-.88 2.22Zm-3.83-.5a2.29 2.29 0 0 0 3.77-.792c.115-.295.17-.611.16-.928A2.36 2.36 0 0 0 73 8.28a2.29 2.29 0 0 0-3.26 0 2.36 2.36 0 0 0-.63 1.72 2.359 2.359 0 0 0 .67 1.72ZM75.58 13V7h.93l2.92 4.67V7h.77v6h-.8l-3.05-4.89V13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.14 21.75A4.26 4.26 0 1 0 72.41 26a4.19 4.19 0 0 0-4.27-4.25m0 6.83a2.579 2.579 0 0 1-.753-5.09A2.58 2.58 0 0 1 70.54 26a2.46 2.46 0 0 1-2.4 2.58m-9.32-6.83A4.26 4.26 0 1 0 63.09 26a4.19 4.19 0 0 0-4.27-4.25m0 6.83a2.579 2.579 0 0 1-.753-5.09A2.58 2.58 0 0 1 61.22 26a2.46 2.46 0 0 1-2.4 2.58m-11.08-5.52v1.8h4.32a3.77 3.77 0 0 1-1 2.27 4.418 4.418 0 0 1-3.34 1.32 4.8 4.8 0 0 1 0-9.6A4.64 4.64 0 0 1 51 20.14l1.27-1.27a6.301 6.301 0 0 0-4.53-1.82 6.611 6.611 0 1 0 0 13.21 6.07 6.07 0 0 0 4.61-1.85 6 6 0 0 0 1.56-4.23 6.265 6.265 0 0 0-.09-1.12zm45.31 1.4a4 4 0 0 0-3.64-2.71 4.001 4.001 0 0 0-4 4.25 4.23 4.23 0 0 0 7.76 2.37l-1.45-1a2.41 2.41 0 0 1-2.09 1.17 2.15 2.15 0 0 1-2.06-1.29l5.69-2.35zm-5.8 1.42a2.328 2.328 0 0 1 2.23-2.48 1.641 1.641 0 0 1 1.57.9zM82.63 30h1.87V17.5h-1.87zm-3.06-7.3h-.07a2.94 2.94 0 0 0-2.24-.95 4.26 4.26 0 0 0 0 8.51 2.88 2.88 0 0 0 2.24-1h.07v.61c0 1.63-.87 2.5-2.27 2.5a2.36 2.36 0 0 1-2.15-1.51l-1.62.67a4 4 0 0 0 3.77 2.52c2.19 0 4-1.29 4-4.43V22h-1.73zm-2.15 5.88a2.58 2.58 0 0 1 0-5.15A2.393 2.393 0 0 1 79.7 26a2.381 2.381 0 0 1-2.28 2.58m24.39-11.08h-4.48V30h1.87v-4.74h2.61a3.89 3.89 0 1 0 0-7.76m0 6H99.2v-4.26h2.65a2.138 2.138 0 0 1 1.513 3.653 2.138 2.138 0 0 1-1.513.627zm11.54-1.79a3.49 3.49 0 0 0-3.33 1.91l1.65.69a1.783 1.783 0 0 1 1.71-.91 1.802 1.802 0 0 1 2 1.61v.12a4.181 4.181 0 0 0-1.95-.48c-1.78 0-3.6 1-3.6 2.82a2.899 2.899 0 0 0 .973 2.034 2.89 2.89 0 0 0 2.137.716 2.649 2.649 0 0 0 2.38-1.22h.06v1h1.8v-4.81c0-2.19-1.66-3.46-3.79-3.46zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-1 1.06-1.34 2-1.34a3.321 3.321 0 0 1 1.7.42 2.26 2.26 0 0 1-2.2 2zM123.74 22l-2.14 5.42h-.06L119.32 22h-2l3.33 7.58-1.9 4.21h2L125.82 22zm-16.8 8h1.86V17.5h-1.86z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#play-store-black_svg__a)",
    d: "M10.44 7.54a2 2 0 0 0-.44 1.4v22.12a1.94 1.94 0 0 0 .47 1.4l.07.08L22.9 20.15v-.3L10.51 7.47z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#play-store-black_svg__b)",
    d: "m27 24.28-4.1-4.13v-.3l4.1-4.13.09.06L32 18.56c1.4.79 1.4 2.09 0 2.89l-4.89 2.78z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#play-store-black_svg__c)",
    d: "M27.12 24.23 22.9 20 10.44 32.46a1.62 1.62 0 0 0 2.07.07z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#play-store-black_svg__d)",
    d: "m27.12 15.78-14.61-8.3a1.61 1.61 0 0 0-2.07.06L22.9 20z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m27 24.13-14.49 8.25a1.66 1.66 0 0 1-2 0l-.07.07.07.08a1.66 1.66 0 0 0 2 0l14.61-8.3z",
    opacity: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.44 32.32a2 2 0 0 1-.44-1.41v.15a1.94 1.94 0 0 0 .47 1.4l.07-.07zM32 21.3l-5 2.83.09.1L32 21.44A1.75 1.75 0 0 0 33.06 20 1.86 1.86 0 0 1 32 21.3",
    opacity: 0.12
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.51 7.62 32 18.7a1.86 1.86 0 0 1 1.06 1.3A1.75 1.75 0 0 0 32 18.56L12.51 7.48C11.12 6.68 10 7.34 10 8.94v.15c0-1.6 1.12-2.26 2.51-1.47",
    opacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "play-store-black_svg__a",
    x1: 21.8,
    x2: 5.02,
    y1: 8.71,
    y2: 25.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "play-store-black_svg__b",
    x1: 33.83,
    x2: 9.64,
    y1: 20,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "play-store-black_svg__c",
    x1: 24.83,
    x2: 2.07,
    y1: 22.3,
    y2: 45.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "play-store-black_svg__d",
    x1: 7.3,
    x2: 17.46,
    y1: 0.18,
    y2: 10.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
export default SvgPlayStoreBlack;